export default __webpack_public_path__ + "static/media/7.ed3086b2.png";